import { render } from "./App.vue?vue&type=template&id=6fa95fc4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6fa95fc4&lang=css"

import exportComponent from "/home/edmeen/web/fibo369/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__